import './VenueClubDetailsPage.css';
import HeroSectionBox from './custom-comp/HeroSectionBox.jsx';
import MenuSection from './custom-comp/MenuSection.jsx';
import RecommendedClub from './custom-comp/RecommendedClub.jsx';
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import FooterTagSection from './custom-comp/FooterTagSection.js';
import { API_BASE_URL } from '../utils.js';
import { ConstructionRounded } from '@mui/icons-material';
import { useGeoLocation } from '../context/LocationContext.js';
import { useQuery } from '@tanstack/react-query';
import Loginpopup from '../Navbar/Loginmodal.js';


export default function VenueClubDetailsPage() {

  const userdata = localStorage.getItem("userData");
  const userId = userdata ? JSON.parse(userdata).id : null;

  const navigate = useNavigate();
  const { latitude, longitude } = useGeoLocation();
  const [partypackages, setPartypackages] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [teasers, setTeasers] = useState([]);
  const [events, setEvents] = useState([]);
  const [menus, setMenus] = useState([]);
  const [showLoginPopup, setShowLoginPopup] = useState(false);



  // const { city, area, clubname } = useParams();

  const { clubInfo } = useParams();
  const [clubname, city, area] = clubInfo?.split("-").map((str) => str.replace(/_/g, "-")) || [];

  // console.log("clubInfo", clubInfo);


  // ✅ React Query fetch function
  const fetchClubDetails = async ({ queryKey }) => {
    const [_key, slug] = queryKey;

    const formData = new FormData();
    formData.append("slug", slug);

    const response = await axios.post(`${API_BASE_URL}/master/APIs/Web/getClubDetails`, formData);
    if (!response.data.status) {
      throw new Error("Failed to fetch club details");
    }
    return response.data.data;
  };

  const { data: data = [], isLoading, isError, error } = useQuery({
    queryKey: ["clubDetails", clubInfo],
    queryFn: fetchClubDetails,
    enabled: !!clubInfo,
    staleTime: 1000 * 60 * 60 * 5,
    cacheTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retry: 2,

  });


  // ✅ Fetch function for recommended clubs
  const fetchRecommendedClubs = async ({ queryKey }) => {
    const [_key, { latitude, longitude }] = queryKey;

    const formData = new FormData();
    formData.append("latitude", latitude);
    formData.append("longitude", longitude);

    const response = await axios.post(`${API_BASE_URL}/master/APIs/Common/recommendedClub`, formData);
    if (!response.data.status) {
      throw new Error("Failed to fetch recommended clubs");
    }
    // Convert object to array
    return Object.values(response.data.data);
  };

  // ✅ useQuery hook
  const { data: recomendedClubData = [], isLoading: recommendedClubsLoading, isError: recommendedClubsisError, error: recommendedClubsError } = useQuery({
    queryKey: ["recommendedClubs", { latitude, longitude }],
    queryFn: fetchRecommendedClubs,
    enabled: latitude !== null && longitude !== null, // only fetch if coordinates exist
    staleTime: 1000 * 60 * 60 * 5, // cache for 5 hours
    cacheTime: 1000 * 60 * 60 * 24, // keep cache for 24 hours
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,

  });





  useEffect(() => {
    if (data) {
      setPartypackages(data.party_packages || []);
      setGallery(data.gallery || []);
      setTeasers(data.teasers || []);
      setEvents(data.events || []);
      setMenus(data.club_menu || []);
    }
  }, [data]);



  useEffect(() => {
    window.scrollTo(0, 0);
  }, [clubInfo]);


  const handleLogin = useCallback((ud) => {
    if (ud) {
      localStorage.setItem("userData", JSON.stringify(ud));
      window.location.reload();
      setShowLoginPopup(false);
    }
  }, []);


  return (
    <>
      {showLoginPopup && <Loginpopup clbk={handleLogin} isbackendUrl={true} />}
      <div className='vcdp-section '>
        <div className='vcdp-container'>
          <HeroSectionBox data={data} />
          <div className='vcdp-content-container'>
            <MenuSection partypackages={partypackages} data={data} events={events} gallery={gallery} teasers={teasers} menus={menus} />
            <RecommendedClub recomendedClubData={recomendedClubData} />
            <FooterTagSection clubInfo={clubInfo} />
          </div>
          <div className="partywitty-pay-footer">
            <button
              className={`partywitty-pay-proceed-btn ${!data?.id ? "disabled" : ""}`}
              disabled={!data?.id}
              onClick={() => {
                if (!data?.id) return;

                if (userId != null) {
                  navigate(
                    `/partywitty-pay?club_id=${data.id}&club_name=${encodeURIComponent(
                      data.name
                    )}&city=${encodeURIComponent(city)}&area=${encodeURIComponent(
                      area
                    )}&address=${encodeURIComponent(data.address)}&img=${encodeURIComponent(
                      data.banner[0]?.img || ""
                    )}`
                  );
                } else {
                  setShowLoginPopup(true);
                }
              }}
            >
              Pay Now | Flat {data?.pwPayDiscount || 0 }% off
            </button>
          </div>

        </div>
      </div>
    </>
  )
}
